define('RPCModel', [
	'RPC',
	'Model'
], function (
	/** RPC */RPC,
	/** Model */Model
) {
	"use strict";

	/**
	 * Класс модели работающей через RPC
	 * @class RPCModel
	 * @constructs RPCModel
	 * @extends Model
	 */
	var RPCModel = Model.extend(/** @lends RPCModel.prototype */{
		/**
		 * Транспорт
		 * @type {RPC}
		 */
		request: RPC
	});


	// Export
	return RPCModel;
});
